import { Helmet } from "react-helmet";

export const FontStyles = () => (
    <Helmet>
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );